import { CreateMapping } from 'Store/common/common.types'
import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  PointRedeemReq,
  PointRedeemRes,
  UpdateRedeemStatusReq,
  ActionRes,
  PointListReq,
  PointListRes,
} from './types'

export const getRedeemListAction = createAsyncAction(
  'POINT/GET_REDEEM_LIST_REQ',
  'POINT/GET_REDEEM_LIST_SUCCESS',
  'POINT/GET_REDEEM_LIST_FAILURE',
)<PointRedeemReq, PointRedeemRes, Error>()

export const updateRedeemStatusAction = createAsyncAction(
  'POINT/UPDATE_REDEEM_STATUS_REQ',
  'POINT/UPDATE_REDEEM_STATUS_SUCCESS',
  'POINT/UPDATE_REDEEM_STATUS_FAILURE',
)<UpdateRedeemStatusReq, ActionRes, Error>()

export const getPointListAction = createAsyncAction(
  'POINT/GET_POINT_LIST_REQ',
  'POINT/GET_POINT_LIST_SUCCESS',
  'POINT/GET_POINT_LIST_FAILURE',
)<PointListReq, PointListRes, Error>()

export const clearEventAction = createStandardAction('POINT/CLEAR_EVENT')<void>()
